import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from '../styles';

interface IProps {
	label: string;
	title: string;
}

export const RuleRegularLabel: React.FC<IProps> = ({ label, title }) => {
	return (
		<span className={css(styleSheet.infoPair)}>
			<span className={css(styleSheet.infoTitle)}>{title}</span>
			<span className={css(styleSheet.infoValue)}>{label}</span>
		</span>
	);
};
